import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { ProfitLossInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: ProfitLossInfo[];
  ccy?: BackportingEnums.CcyEnum;
  consolidation?: boolean;
  showConversionRate?: boolean;
}

const FIRST_TABLE_FIELDS = [
  // 'consolidation',
  'reportingPeriod',
  'currencyOfAccounts',
];
const CONVERSION_TABLE_FIELDS: string[] = [
  'currencyConversion',
  'currencyConversionRate',
  // 'empty',
];
const REMAINING_TABLE_FIELDS = [
  'turnover',
  'otherOperatingIncome',
  'otherOperatingExpense',
  'costOfGoodsSold',
  'grossProfitLoss',
  'operatingExpenses',
  'ebitda',
  'operatingProfitLoss',
  'cashFlow',
  'financialIncome',
  'financialExpense',
  'financingNetResult',
  'profitLossBeforeTax',
  'taxOnProfit',
  'profitLossAfterTax',
  'dividends',
  'retainedEarnings',
  'rndExpense',
];

const FinancialsPL: React.FC<Props> = ({
  data,
  ccy,
  consolidation = undefined,
  showConversionRate,
}) => {
  const tableFields = showConversionRate
    ? FIRST_TABLE_FIELDS.concat(CONVERSION_TABLE_FIELDS).concat(REMAINING_TABLE_FIELDS)
    : FIRST_TABLE_FIELDS.concat(REMAINING_TABLE_FIELDS);
  return (
    <MatrixDataTable
      title={'pl'}
      translationsScope={'companies:companyFinancials'}
      data={data}
      tableFields={tableFields}
      showCurrency={true}
      ccy={ccy}
      consolidation={consolidation}
    />
  );
};

export default FinancialsPL;
